import { useState, useCallback, useEffect } from 'react';

import CountUp from 'react-countup';

import axios from 'axios';

const Estadisticas = ({ verifyToken, division }) =>
{
    const [fetch, setFetch] = useState(false);
    const [estadisticas, setEstadisticas] = useState([]);

    const appDebug = process.env.REACT_APP_DEBUG;
    const apiUrl = process.env.REACT_APP_API_URL;
    const secretKey = process.env.REACT_APP_SECRET_KEY;

    const fetchData = useCallback(async () =>
    {
        setFetch(true);

        try
        {
            const response = await axios.get(`${apiUrl}${division}/estadisticas?environment=local`);

            const estadisticas = verifyToken(response, appDebug, secretKey);

            if (estadisticas.length === 0) { return console.log(new Error('Signature is not valid.')); }

            setEstadisticas(estadisticas.data);
        }
        catch (error)
        {
            console.error(error);
        }
    }, [appDebug, apiUrl, secretKey, verifyToken]);

    useEffect(() =>
    {
        fetch === false && fetchData();
    }, [fetchData, fetch]);

    return (
        estadisticas.length > 0 &&
        (
            <div className="row g-1 mt-1 mb-2 ps-10 pe-10">
                <div className="col-12">
                    <div className="card-group shadow">

                        {
                            estadisticas.map((estadistica, index) =>
                            (
                                <div key={index} className="card bg-transparent">
                                    <div className="card-body text-center">
                                        <h2 className="fw-bold azulIfop estadisticas-numero">
                                            <CountUp end={estadistica.data} duration={3} />
                                        </h2>
                                        <p className="text-muted estadisticas-texto">{estadistica.titulo}</p>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>
            </div>
        )
    );
}

export default Estadisticas;
